import { anyOf, arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string, number, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isMediaLibraryAssetDataResult = objectOf({
  asset: objectOf({
    app_group_id: string,
    id: string,
    name: string,
    ext: string,
    type: string,
    size: number,
    url: string,
    created_at: number,
    tag_names: arrayOf(string),
    territory_ids: arrayOf(string),
    ratio: maybe(number),
    known_height: maybe(number),
    known_width: maybe(number),
    last_edited_by: maybe(string),
    created_by: maybe(string),
    src: anyOf(string, nullValidation),
  }),
});
